import React from 'react';

function Resources() {
    return (
        <div>
            <h1>Tools and Resources</h1>
            <ul style={{listStyle:'none'}}>
                <li> <a href="https://github.com">Github</a></li>
                <li><a href="https://Figma.com">Figma</a> </li>
                <li><a href="https://Slack.com">Slack</a> </li>
                <li><a href="https://https://drive.google.com/">Drive</a></li>
            </ul>
        </div>
    );
}

export default Resources;
